import angular from 'angular';
class CooperativeSvc {
    /* @ngInject */
    constructor(CommunityDA) {
        this.communityDA = CommunityDA;
    }
    /**
     * Récupèration des groupement lié à une communauté
     */
    getAllCooperativesOfCommunity(communityEid, pageNumber, size) {
        return this.communityDA.getAllCooperativesOfCommunity(communityEid, pageNumber, size);
    }
    /**
     * Enregistrement d'un nouveau groupement
     */
    saveCooperative(cooperative) {
        return this.communityDA.saveCooperative(cooperative);
    }
    /**
     * MAJ d'un groupement
     */
    updateCooperative(cooperative) {
        return this.communityDA.updateCooperative(cooperative);
    }

    /**
     * Récupèration des groupement par id
     */
    getCooperative(id) {
        return this.communityDA.getCooperative(id);
    }

    /**
    * Retourne True si le groupement est supprimable.
    * @param id Identifiant du groupement
    */
    isCooperativeDeletable(id) {
        return this.communityDA.isCooperativeDeletable(id);
    }

    /**
     * Supprime un groupement.
     * @param id Identifiant d'un groupement
     */
    deleteCooperative(id) {
        return this.communityDA.deleteCooperative(id);
    }
}
angular.module('app.community').service('CooperativeSvc', CooperativeSvc);